import { MkIcon } from "@/mk/MkIcon";
interface Props {
    page: number;
    total: number;
    pageSize?: number;
    onChange?(page: number): void;
    className?: string;
}

export function MkPagination({ page, total, pageSize = 10, onChange, className }: Props) {
    const pages = Math.max(1, Math.ceil(total / pageSize));
    const current = Math.min(Math.max(1, page), pages);

    let from = Math.max(1, current - 2);
    const to = Math.min(pages, from + 4);
    from = Math.max(1, to - 4);
    const span: number[] = [];
    for (let index = from; index <= to; index += 1) {
        span.push(index);
    }
    const first = span[0] ?? 1;
    const last = span[span.length - 1] ?? pages;

    function go(next: number) {
        if (next < 1 || next > pages || next === current) {
            return;
        }
        onChange?.(next);
    }

    return (
        <div className={`mk-pagination${className ? ` ${className}` : ""}`}>
            <button className="mk-page-btn" disabled={current <= 1} onClick={() => go(current - 1)}>
                <MkIcon name="fa-angle-left" />
            </button>
            {first > 1 && (
                <>
                    <button className="mk-page-btn" onClick={() => go(1)}>1</button>
                    {first > 2 && <span className="mk-page-ellipsis">…</span>}
                </>
            )}
            {span.map((value) => (
                <button key={value} className={`mk-page-btn${value === current ? " mk-page-active" : ""}`}
                        onClick={() => go(value)}>
                    {value}
                </button>
            ))}
            {last < pages && (
                <>
                    {last < pages - 1 && <span className="mk-page-ellipsis">…</span>}
                    <button className="mk-page-btn" onClick={() => go(pages)}>{pages}</button>
                </>
            )}
            <button className="mk-page-btn" disabled={current >= pages} onClick={() => go(current + 1)}>
                <MkIcon name="fa-angle-right" />
            </button>
        </div>
    );
}
